// Module
var code = `<div class="sss-online-employer-payment">
  <form name="\$ctrl.commandForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Payor type:</td>
        <td>
          <select name="payorKind"
                  ng-model="\$ctrl.payorKind"
                  ng-required="true">
            <option value="INDIVIDUAL">Individual</option>
            <option value="EMPLOYER">Employer</option>
          </select>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Payment Reference Number:</td>
        <td>
          <input type="text"
                 ng-change="\$ctrl.onPrnChanged()"
                 required
                 ng-model="\$ctrl.paymentReferenceNumber"
                 name="paymentReferenceNumber"
          />
        </td>
        <td>
          <button
              type="button"
              class="btn btn-success"
              ng-click="\$ctrl.fetchByPrn()"
              ng-disabled="!\$ctrl.paymentReferenceNumber">
            Check
          </button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Individual name:</td>
        <td>
          <input disabled
                 type="text"
                 ng-model="\$ctrl.payment.payorName"/>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Individual number:</td>
        <td>
          <input
              disabled
              ui-mask="99-9999999-9"
              ng-model="\$ctrl.payment.ssNumber"
              type="text"
          />
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Amount:</td>
        <td>
          <cash ng-disabled="true"
            ng-model="\$ctrl.payment.amount"></cash>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Starting period:</td>
        <td>
          <input disabled
                 type="text"
                 ng-model="\$ctrl.payment.startingPeriod"/>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Ending period:</td>
        <td>
          <input disabled
                 type="text"
                 ng-model="\$ctrl.payment.endingPeriod"/>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
    <validator condition="\$ctrl.payment"></validator>
    <div class="buttons">
      <button
          type="button"
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.commandForm.\$pristine"
          ng-click="\$ctrl.cancelAction()">
        Cancel
      </button>
      <button
          type="submit"
          class="misc-transaction__save btn btn-success"
          ng-disabled="\$ctrl.commandForm.\$invalid"
          ng-click="\$ctrl.save()">
        Submit payment
      </button>
    </div>
  </form>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/sss-online-payment/sss-online-individual-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;